import React from 'react'
import { cart_img, country_img, home_img, lock_dash_img } from '../../assets/imgs'

const LocationBox = ({ list }) => {
    return (
        <div>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 primary">
                Locations
            </p>
            <div className='d-flex flex-wrap gap-4 '>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={country_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_countries}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Country</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={home_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_states}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total State</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_cities}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total City</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={cart_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_areas}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Area</h4>
                </div>
            </div>
        </div>
    )
}

export default LocationBox